import { createTheme } from "@material-ui/core/styles";

export const LocalizationTheme = () =>
	createTheme({
		typography: {
			useNextVariants: true,
		},
		overrides: {
			MuiIcon: {
				root: {
					fontSize: "1rem",
				},
			},
			MuiTable: {
				root: {
					width: "98%",
					margin: "auto",
				},
			},
			MuiTableCell: {
				head: {
					fontWeight: "600",
				},
				footer: {
					border: "unset",
				},
			},
			MuiInput: {
				underline: {
					"&:after": {
						borderBottomColor: "#53B3EA !important",
					},
				},
			},
		},
	});

export const SelectTheme = () =>
	createTheme({
		palette: {
			primary: {
				main: "#53B3EA",
			},
			error: {
				main: "#C4455B",
			},
		},
		typography: {
			useNextVariants: true,
		},
		overrides: {
			MuiInputBase: {
				root: {
					backgroundColor: "white",
					"& .fontSizeOverride": {
						fontSize: "14px !important",
					},
				},
			},
			MuiFormGroup: {
				root: {
					paddingLeft: "0px",
				},
			},
			MuiFormLabel: {
				root: {
					"&$focused": {
						color: "#53B3EA",
					},
				},
			},
			MuiOutlinedInput: {
				root: {
					"&$focused": {
						notchedOutline: {
							borderColor: "#53B3EA !important",
						},
					},
				},
				multiline: {
					padding: "0 !important",
				},
				input: {
					padding: "9px 14px !important",
				},
			},
			MuiInputLabel: {
				outlined: {
					transform: "translate(14px, 11px) scale(1)",
				},
			},
		},
	});

export const DatePickerTheme = () =>
	createTheme({
		MuiInput: {
			root: {
				"& input::-webkit-clear-button": {
					display: "none",
				},
			},
		},
	});

const buildEnhancedDropdownTheme = (addMarginBottom) =>
	createTheme({
		palette: {
			primary: {
				main: "#53B3EA",
			},
			error: {
				main: "#C4455B",
			},
		},
		typography: {
			useNextVariants: true,
		},
		overrides: {
			MuiFormControl: {
				root: {
					width: "100%",
					marginBottom: addMarginBottom ? "16px" : "0",
				},
			},
			MuiMenuItem: {
				root: {
					fontSize: "14px",
				},
			},
			MuiSelect: {
				root: {
					backgroundColor: '#FFF'
				},
				outlined: {
					'&:focus': {
						backgroundColor: '#FFF'
					}
				}
			},
			MuiInputLabel: {
				outlined: {
					transform: "translate(14px, 11px) scale(1)",
				},
				root: {
					"&$error": {
						color: "#0000008a",
					},
				},
				asterisk: {
					color: "#0000008a !important",
				},
			},
			MuiOutlinedInput: {
				root: {
					"&$error $notchedOutline": {
						borderColor: "#0000003b",
					},
					"&$error$focused $notchedOutline": {
						borderColor: "#53B3EA",
					},
					"&$error:hover $notchedOutline": {
						borderColor: "#000000de",
					},
					"&$error$focused:hover $notchedOutline": {
						borderColor: "#53B3EA",
					},
					"&$focused $notchedOutline": {
						borderColor: "#53B3EA",
					},
					"&:hover $notchedOutline": {
						borderColor: "#000000de",
					},
				},
				multiline: {
					padding: "0 !important",
				},
				input: {
					padding: "9px 14px !important",
				},
			},
		},
	});

// Built once at module load. Passing a freshly created theme (or a new theme
// factory) on every render makes MUI regenerate the JSS stylesheets of every
// descendant, which is what made forms with several dropdowns crawl while typing.
export const EnhancedDropdownThemeWithMargin = buildEnhancedDropdownTheme(true);
export const EnhancedDropdownThemeWithoutMargin = buildEnhancedDropdownTheme(false);
